module.exports = __webpack_public_path__ + "img/consultoria-y-proyectos.96eb9b4e.png";